var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessage2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9189 7.37598L11.2161 10.3868C10.5165 10.9418 9.53226 10.9418 8.83268 10.3868L5.09869 7.37598",
    stroke: "#99AEA2",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0907 17.5C16.6252 17.507 18.3334 15.4246 18.3334 12.8653V7.14168C18.3334 4.58235 16.6252 2.5 14.0907 2.5H5.9093C3.37484 2.5 1.66669 4.58235 1.66669 7.14168V12.8653C1.66669 15.4246 3.37484 17.507 5.9093 17.5H14.0907Z",
    stroke: "#99AEA2",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage2);
export default __webpack_public_path__ + "static/media/message_2.b0f73db271f430021f33117b46bbae0d.svg";
export { ForwardRef as ReactComponent };